import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { Link } from '@tanstack/react-router'
import RoutableLinkIcon from '../../components/RoutableLinkIcon'
import { formatTimestamp } from '../../utils/util'
export const getColumns = ({
  status,
  isFailedApi,
  isFailedBank,
  isFailedUnknown,
}: {
  status: string
  isFailedApi: boolean
  isFailedBank: boolean
  isFailedUnknown?: boolean
}) => {
  const baseColumns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      width: 110,
      renderCell: (params: GridRenderCellParams) => {
        const { paymentProcessorKind, externalRefId } = params.row

        return (
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <Link to={`/payments/${params.value}`}>{params.value}</Link>
            <RoutableLinkIcon paymentProcessorKind={paymentProcessorKind} externalRefId={externalRefId} />
          </span>
        )
      },
    },
    {
      field: 'payeeId',
      headerName: 'Driver ID',
      flex: 1,
      maxWidth: 300,
    },
    {
      field: 'amount',
      headerName: 'Amount',
      width: 110,
      type: 'number',
      headerAlign: 'left',
      align: 'left',
      valueFormatter: (value: number | undefined) => {
        if (typeof value === 'number') {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          }).format(value / 100)
        }
        return value
      },
    },
  ]

  if (!['OPEN', 'UNDER_REVIEW'].includes(status)) {
    baseColumns.push({
      field: 'paymentOption',
      headerName: 'Payment Speed',
      width: 180,
    })
  }

  if (['ENQUEUED_FOR_RELEASE'].includes(status) && !isFailedApi && !isFailedBank) {
    baseColumns.push({
      field: 'isBankError',
      headerName: 'Bank Error',
      type: 'boolean',
      width: 120,
      valueFormatter: (value: boolean | undefined) => (value ? 'Yes' : 'No'),
    })
  }

  if (isFailedApi || isFailedUnknown) {
    baseColumns.push({
      field: 'paymentErrorMessage',
      headerName: 'Error',
      flex: 1,
      type: 'string',
      filterable: false,
      sortable: false,
    })
  }

  baseColumns.push(
    {
      field: 'createdAt',
      headerName: 'Created',
      width: 180,
      type: 'dateTime',
      valueFormatter: (value: string | Date) => formatTimestamp(value),
    },
    {
      field: 'updatedAt',
      headerName: 'Updated',
      width: 180,
      type: 'dateTime',
      valueFormatter: (value: string | Date) => formatTimestamp(value),
    }
  )

  return baseColumns
}
